import { Box, Container, Grid, styled, useTheme } from "@mui/material";
import { SanaCashTypographyLogo } from "assets/Icon";

import { login } from "config/authentication";

import { useEffect } from "react";

function SanaAnimationLoading() {
  const theme = useTheme();
  useEffect(() => {
    setTimeout(() => {
      login();
    }, 3000);
  }, []);

  return (
    <Container>
      <Grid container>
        <GridStyle item xs={12}>
          <SanaCashTypographyLogo />
        </GridStyle>

        <Versioning>V2.0.0</Versioning>
      </Grid>
    </Container>
  );
}

const GridStyle = styled(Grid)(({ theme }) => ({
  width: "100%",
  height: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  strokeDasharray: 487,
  strokeDashoffset: 487,

  svg: {
    stroke: "#fff",
    strokeWidth: "3px",
    fill: "transparent",
    maxWidth: "30%",
    animation: "complete-big-line 3s ease-in-out alternate infinite",
    [theme.breakpoints.down('sm')]: {
      maxWidth: "70%",
    }
  },

  "@keyframes complete-big-line": {
    "0%": {
      strokeDashoffset: 487,
    },
    "100%": {
      strokeDashoffset: 0,
    },
  },
}));

const Versioning = styled(Box)(({ theme }) => ({
  position: "fixed",
  bottom: "20px",
  right: "20px",
  color: theme.palette.text.secondary,
  fontSize: "12px",
}));

export default SanaAnimationLoading;
